// extracted by mini-css-extract-plugin
module.exports = {"ContactUsText":"ContactUsText_ContactUsText__voNUk","ContactUsText__email":"ContactUsText_ContactUsText__email__oqWjA"};